export default __webpack_public_path__ + "static/media/hht1_ep09_timeline_q02_b.5e461c0e.png";